import { apiHost } from '../../../config';
import { deleteRequest } from '../../requests';

export default async function deleteStudent(id: number) {
  return deleteRequest(`${apiHost}/api/teacher/users/${id}`);
}
